export default {
  'editionSettings': {
    'key': 'espnph-en',
    'site': 'espn',
    'language': 'en',
    'country': 'ph',
    'domain': 'tv5.espn.com',
    'editionSiteId': '30',
    'https': true
  },
  'navId': '20341629',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'GB'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'Asia/Manila',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'PHT',
    'timeZoneBucket': 'Australia/Melbourne',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY' : 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'ddd, M/D': 'ddd, D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'outbrain': {
    'enabled': true,
    'template': 'ESPNPhilippines',
    'desktop': {
      'compliantId': 'AR_15',
      'nonCompliantId': 'AR_12'
    },
    'mobile': {
      'compliantId': 'MR_4',
      'nonCompliantId': 'MB_5'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'recap': {
      'desktop': {
        'compliantId': 'AR_6',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_3',
        'nonCompliantId': 'MB_9'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'partnerAd': false,
    'dev-config': 22029737,
    'qa-config': 22029737,
    'prod-config': 22029737
  },
  'partnerModules': {
    'global': true,
    'nba': true,
    'womenbb': true,
    'golf': true,
    'endurance': true,
    'horse': true,
    'nascar': true
  },
  'sportBranding': [
    {
      'sport': 'cricket',
      'image': 'logo-uk-cricinfo',
      'url': null
    },
    {
      'sport': 'soccer',
      'image': 'logo-uk-fc',
      'url': null
    },
    {
      'sport': 'rugby',
      'image': 'logo-uk-scrum',
      'url': null
    },
    {
      'sport': 'ncaaw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'ncw',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'wnba',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    },
    {
      'sport': 'womenbb',
      'image': 'ESPNcom-powerby-espnw',
      'url': 'http://www.espnw.com'
    }
  ],
  'siteLogo': {
    'class': 'espn-tv5',
    'featurePhone': {
      'name': 'tv5-espn-logo',
      'width': 94,
      'height': 30
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NBA, PBA, American NCAA Basketball, eSports, NFL, Boxing and more.',
    'defaultMetaImage': 'espn_red.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com',
        'locale': 'en_US'
      }
    }
  },
  'appDetails': {
    'ios': {
      'id': '317469184',
      'name': 'ESPN',
      'deepLinkUrl': 'ios-app://317469184/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    },
    'android': {
      'id': 'com.espn.score_center',
      'name': 'ESPN',
      'deepLinkUrl': 'android-app://com.espn.score_center/sportscenter',
      'deepLinkUrlScheme': 'sportscenter'
    }
  },  
  'shop': {
    'enabled': false
  },
  'sportReplacements': {},
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
      '/oly/summer/cycling/': '/oly/summer/cycling/',
      '/college-football/': '/ncf/',
      '/football/club': '/soccer/team',
      '/football/': '/soccer/',
      '/racing/nascar/': '/nascar/',
      '/racing/': '/rpm/',
      '/mens-college-basketball/': '/ncb/',
      '/womens-college-basketball/': '/ncw/',
      '/womens-basketball/': '/womenbb/',
      '/olympics/': '/oly/',
      '/cycling/': '/cycling/',
      '/figure-skating/': '/oly/',
      '/college-sports/': '/ncaa/',
      '/gymnastics/': '/oly/',
      '/skiing/': '/oly/',
      '/horse-racing/': '/horse/',
      '/sports/womenbb/': '/womenbb/',
      '/sports/horse/': '/horse/',
      '/nba-summer-league/': '/nba/summerleague/',
      '/espn/rss/football/': '/espn/rss/soccer/'
    },
    'pathSegments': {
      'table': 'standings',
      'fixtures': 'schedule'
    },
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': false,
    'game': {
      'enabled': false
    }
  },
  'ticketProvider': 'stubHub',
  'showFavorites': true,
  'showMobileScoresLink': true,
  'favoriteSportsManagement': true,
  'showInsider': false,
  'showWatch' : true,
  'showCategory': true,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': true,
  'cookieConsent': true,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': true,
  'hasTickets': true,
  'searchUrl': 'http://search.espn.com/',
  'hasSearch': false,
  'gameSettings': {
    'topEventsId': 4379198,
    'promotedSoccerLeaguesCeId': 20341678,
    'showBroadcast': false
  },
  'fallback': {
  },
  'editionAlert': {
    'enabled': true,
    'text': 'You have come to the Philippines Edition, for other ESPN editions, click here.'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'Story',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
  },
  'tier3NavIds': {
  },
  'latestVideoCollectionId': 20341683,
  'videoAutoStart': {
    'index': false,
    'scoreboard': false
  },
  'useMongo': true,
  'activeSite': true,
  'countries': [
    {
      'name': 'Philippines',
      'country-code': 'ph',
      'showHreflang': true
    }
  ]
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/philippines.js